import React, { useRef } from 'react'

import { t } from 'src/translations'

import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay
} from 'shared/components/common/modal'

import { SearchResults } from './SearchResults'
import { SearchInput } from './SearchInput'
import { A11yProvider } from '../../online_ordering/useA11y'

type SearchModalProps = {
  isOpen: boolean
  onClose: () => void
  channelGuid?: string | null
}

export const SearchModal = ({
  isOpen,
  onClose,
  channelGuid
}: SearchModalProps) => {
  const searchModalContentRef = useRef<HTMLDivElement>(null)

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        contentClassName='modalContentV2 searchModal fullScreenMobile'
        contentRef={searchModalContentRef}
        ariaLabelledBy='search-modal-title'
        initialFocusElementId='search-modal-input'
      >
        <h2 className='searchModalHeader'>
          <span id='search-modal-title'>{t('search-modal.header')}</span>
          <ModalCloseButton />
        </h2>
        <div className='searchInputContainer'>
          <SearchInput
            placeholder={t('search-modal.search-input-placeholder')}
            autoFocus={isOpen}
            ariaDescribedBy='search-results-container'
            ariaLabelledBy='search-modal-title'
          />
        </div>
        <A11yProvider>
          <SearchResults
            channelGuid={channelGuid}
            searchModalContentRef={searchModalContentRef}
            closeSearchModal={onClose}
          />
        </A11yProvider>
      </ModalContent>
    </Modal>
  )
}
